import { useEffect, useState } from 'react';

/**
 * The account menu — sign-out, in every shell (operator, 2026-08-13;
 * docs/UI-BRANDING.md §4.2, B1).
 *
 * « Se déconnecter » was a bare button in every shell; folding it into a menu
 * was the ask. Until U4 (PMS-UNIFIED-DESK-BRIEF §8) the menu also carried the
 * établissement list — the switcher. It went with U4: what you see is your
 * reach, where you write is the object's (M11′), so there is no global
 * établissement left to switch. A page about one établissement chooses inside
 * the page (`PerEtablissement`).
 *
 * B1 stands: the menu stays shared, presentational and domain-free. It does
 * not import `@lemontaigu/pms-core` and cannot. The menu itself stays because
 * sign-out is always there and because this is where the PMS's current day
 * will surface once it exists.
 */

export interface AccountMenuProps {
  onSignOut: () => void;
  signOutLabel?: string;
}

export function AccountMenu({ onSignOut, signOutLabel = 'Se déconnecter' }: AccountMenuProps) {
  const [open, setOpen] = useState(false);

  useEffect(() => {
    if (!open) return;
    const close = () => setOpen(false);
    document.addEventListener('click', close);
    return () => document.removeEventListener('click', close);
  }, [open]);

  return (
    <div className="app-menu app-account" onClick={(e) => e.stopPropagation()}>
      <button
        type="button"
        className="app-menu-btn app-account-btn"
        aria-expanded={open}
        aria-haspopup="menu"
        onClick={() => setOpen(!open)}
      >
        <span className="app-menu-label">Compte</span>
        <span className="app-menu-caret">▾</span>
      </button>
      {open && (
        <div className="app-menu-list app-account-list" role="menu">
          <button
            type="button"
            role="menuitem"
            className="app-menu-signout"
            onClick={() => {
              setOpen(false);
              onSignOut();
            }}
          >
            {signOutLabel}
          </button>
        </div>
      )}
    </div>
  );
}
